// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"meetings_buttonsContainer__235t6","horizontalSpacer":"meetings_horizontalSpacer__uXI6H","spacer":"meetings_spacer__CfGZW","label":"meetings_label__14eKl"};